<footer class="site-footer">
  <div class="footer-content">
    <div class="footer-brand">
      <a class="brand" routerLink="/">
        <span class="brand-mark">M</span>
        <span class="brand-copy">
          <strong>MKZS.tech</strong>
          <small>MKZS Technology Solutions Ltd</small>
        </span>
      </a>
      <p class="tagline">
        Senior .NET and Azure engineering for teams that need architecture thinking and hands-on delivery in the same engagement.
      </p>
      <div class="footer-pills" aria-label="Capabilities">
        <span>Azure Architecture</span>
        <span>.NET Engineering</span>
        <span>Full-Stack Delivery</span>
      </div>
    </div>

    <div class="footer-links">
      <div class="footer-group">
        <span class="group-title">Navigate</span>
        <nav class="footer-nav" aria-label="Footer">
          <a routerLink="/about">About</a>
          <a routerLink="/services">Services</a>
          <a routerLink="/portfolio">Case Studies</a>
          <a routerLink="/contact">Contact</a>
        </nav>
      </div>

      <div class="footer-group">
        <span class="group-title">Policies</span>
        <nav class="footer-nav" aria-label="Policies">
          <a routerLink="/privacy">Privacy</a>
          <a routerLink="/cookies">Cookies</a>
        </nav>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <p class="copyright">&copy; {{ currentYear() }} MKZS Technology Solutions Ltd. All rights reserved.</p>
    <a class="footer-cta" routerLink="/contact">Start a Project</a>
  </div>
</footer>
